module.exports = __webpack_public_path__ + "static/media/part-07.ca9b69b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/part-07.jpg
// module id = 939
// module chunks = 0